import User from '../components/user/User';

function UserView() {
  return (
    <div
      className="content-layout-container"
    >
      <User />
    </div>
  )
}

export default UserView;